// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2Eirt","errorLogs":"styles_errorLogs__1jC0L"};